export const AppConstants = {

  appName: 'OpsNow',

  mode: {
    create: 'create',
    read: 'read',
    update: 'update',
    patch: 'patch',
    delete: 'delete'
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/constants/src/app.constants.ts